// Componente vacio para usarlo en las rutas padres
export default {
  render(c) { return c('router-view') }
}
